import Abstract from "@homer.core/storage";

const storage = (function () {
    try {
        return "sessionStorage" in globalThis && globalThis.sessionStorage.getItem && globalThis.sessionStorage;
    } catch (_) {}

    return false;
})();

class Storage extends Abstract {
    constructor(identifier, options = { version: undefined, lifetime: null }) {
        super(identifier, storage, options);
    }

    static supported = !!storage;
}

export default Storage;
